import { UserComponentsService } from './user/user-components.service';
import { UserService } from 'src/app/shared/services/user.service';
import { DroitAdminGuard, DroitInterfaceGuard } from './../shared/services/auth.guard';
import { GlobalSettingsService } from './gobal-settings.service';
import { AmountComponentService } from './amount.component.service';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { BcComponentsService } from './bc/bc-components.service';
import { BpComponentsService } from './bp/bp-components.service';
import { AuthGuard } from '../shared/services/auth.guard';
import { JwtHelper } from '../shared/services/jwtHelper';
import { BcModule } from './bc/bc.module';
import { BpModule } from './bp/bp.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthentificationComponent } from './authentification/authentification.component';
import { InterfaceComponent } from './interface/interface.component';
import { UserRecordComponent } from './user/user-record/user-record.component';
import { ListUserComponent } from './user/list-user/list-user.component';
import { ModalAddUserComponent } from './user/modal-add-user/modal-add-user.component';
import { TableDroitComponent } from './user/table/table-droit/table-droit.component';
import { GestionArticleComponent } from './gestion-referentiel/gestion-article/gestion-article.component';
import { GestionCa1Component } from './gestion-referentiel/gestion-ca1/gestion-ca1.component';
import { GestionCa2Component } from './gestion-referentiel/gestion-ca2/gestion-ca2.component';
import { GestionCategorieComponent } from './gestion-referentiel/gestion-categorie/gestion-categorie.component';
import { GestionCgChargeComponent } from './gestion-referentiel/gestion-cg-charge/gestion-cg-charge.component';
import { GestionCompComponent } from './gestion-referentiel/gestion-comp/gestion-comp.component';
import { GestionCondReglComponent } from './gestion-referentiel/gestion-cond-regl/gestion-cond-regl.component';
import { GestionModeReglComponent } from './gestion-referentiel/gestion-mode-regl/gestion-mode-regl.component';
import { GestionNaComponent } from './gestion-referentiel/gestion-na/gestion-na.component';
import { GestionReferentielComponent } from './gestion-referentiel/gestion-referentiel.component';
import { GestionSiteComponent } from './gestion-referentiel/gestion-site/gestion-site.component';
import { GestionSocieteComponent } from './gestion-referentiel/gestion-societe/gestion-societe.component';
import { GestionTvaComponent } from './gestion-referentiel/gestion-tva/gestion-tva.component';
import { GestionTypeCompComponent } from './gestion-referentiel/gestion-type-comp/gestion-type-comp.component';
import { GestionReferentielComponentService } from './gestion-referentiel/gestion-referentiel-component.service';
import { GestionActiviteComponent } from './gestion-referentiel/gestion-activite/gestion-activite.component';
import { GestionDestinationComponent } from './gestion-referentiel/gestion-destination/gestion-destination.component';
import { GestionPeriodeSageComponent } from './gestion-referentiel/gestion-periode-sage/gestion-periode-sage.component';
import { GestionActualiteComponent } from './gestion-referentiel/gestion-actualite/gestion-actualite.component';
import { datadogRum } from '@datadog/browser-rum';
import { MaintenanceComponent } from './maintenance/maintenance.component';

export class GenericErrorHandler implements ErrorHandler {
  handleError(error: any): void {
      datadogRum.addError(error);
      console.error(error);
  }
}

@NgModule({
  declarations: [
    LandingPageComponent,
    DashboardComponent,
    AuthentificationComponent,
    InterfaceComponent,
    UserRecordComponent,
    ListUserComponent,
    ModalAddUserComponent,
    TableDroitComponent,
    GestionArticleComponent,
    GestionCa1Component,
    GestionCa2Component,
    GestionCategorieComponent,
    GestionCgChargeComponent,
    GestionCompComponent,
    GestionCondReglComponent,
    GestionModeReglComponent,
    GestionNaComponent,
    MaintenanceComponent,
    GestionReferentielComponent,
    GestionSiteComponent,
    GestionSocieteComponent,
    GestionTvaComponent,
    GestionTypeCompComponent,
    GestionActiviteComponent,
    GestionDestinationComponent,
    GestionPeriodeSageComponent,
    GestionActualiteComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatCardModule,
    BcModule,
    BpModule,
    SharedModule
  ],
  providers:  [
    { provide: ErrorHandler, useClass: GenericErrorHandler },
    BcComponentsService,
    BpComponentsService,
    UserComponentsService,
    AmountComponentService,
    AuthGuard,
    DroitInterfaceGuard,
    DroitAdminGuard,
    JwtHelper,
    GlobalSettingsService,
    GestionReferentielComponentService
  ]
})
export class CoreModule { }
